import { apiGet, apiPost } from '../../utils'

export function showLabelRequestsInReviewAPI(data) {
    return apiGet(`/api/showLabelRequestsInReview`, data)
}

export function actionLabelRequestAdminAPI(data) {
    return apiPost(`/api/actionLabelRequestAdmin`, data)
}

export function deleteB2BFileAdminAPI(data) {
    return apiPost(`/api/deleteB2BFileAdmin`, data)
}

export function getSubAdminsListAdminAPI() {
    return apiGet(`/api/getSubAdminsListAdmin`)
}

export function assignUserToSubAdminsAPI(data) {
    return apiPost(`/api/assignUserToSubAdmins`, data)
}
